// eslint-disable-next-line import/no-anonymous-default-export
export default
{
    SUPPORT_EMAIL: '18',
    CONTACT_COACH: '29',
};
